import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { playSound } from '../../misc/tools';
import { Windows } from '../../pages/MainPage';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './FooterUI.css'

const FooterUI = (props: UIProperties<FooterUIConfig>) => {

	const [isOverPr, setIsOverPr] = useState(false);
	const [isOverTalk, setIsOverTalk] = useState(false);
	const [isOverAction, setIsOverAction] = useState(false);
    
	useEffect(() => {
	}, [isOverPr, isOverTalk, isOverAction])

	return (
		<div className="in-game-ui-container ui-hud-container modal-disable-select">
			<div>
				<img  style={{
					position: 'absolute',
					bottom: '0px',
					width: '710px',
					left: '0px'
				}} src="./assets/images/general/footer/bar_footer.png"/>
				
				<div style={{
					position: 'absolute',
					bottom: '0px',
					left: '0px',
					width: '330px'
				}}>
					<button tabIndex={0} aria-label='Patient Record' className="pointer" style={{
						position: 'relative',
						background: 'transparent',
						pointerEvents: 'auto',
        		    }} onMouseOver={() => {
         		        setIsOverPr(true);
					}} onMouseEnter={() => {
						playSound('./assets/audio/Patient_Menu_Rollover');
					}} onMouseDown={() => {
						setIsOverPr(true);
					}} onMouseUp={() => {
						setIsOverPr(false);
					}} onMouseOut={() => {
						setIsOverPr(false);
					}} onClick={() => {
						props.parameters.onPrClicked();
						playSound('./assets/audio/Patient_Menu_Click');
					}}>
						<img style={{
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_patientrecord_main.png' />
						{isOverPr ? (<img style={{
							position: 'absolute',
							top: '0',
							left: '0',
							width: '100%',
							height: '100%',
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_patientrecord_down.png' />) : (<div></div>)}
					</button>
				</div>

				<div style={{
					position: 'absolute',
					bottom: '0px',
					left: '260px',
					width: '230px',
				}}>
					<button tabIndex={props.parameters.talksZero ? -1 : 0} aria-label={`Talks. There are currently ${props.parameters.talksNum} talks.`} className="pointer" style={{
						position: 'relative',
						background: 'transparent',
						pointerEvents: props.parameters.talksZero ? 'none' : 'all'
       		    	}} onMouseOver={() => {
						setIsOverTalk(true);
					}} onMouseEnter={() => {
						playSound('./assets/audio/Patient_Menu_Rollover');
					}} onMouseDown={() => {
						setIsOverTalk(true);
					}} onMouseUp={() => {
						setIsOverTalk(false);
					}} onMouseOut={() => {
						setIsOverTalk(false);
					}} 
					aria-disabled={props.parameters.talksZero}
					onClick={() => {
						if(props.parameters.talksZero) {
							return;
						}
						playSound('./assets/audio/Patient_Menu_Click');

							props.parameters.onTalksClicked();
					}}>
						<img style={{
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_talk_main.png' />
						{isOverTalk ? (<img style={{
							position: 'absolute',
							top: '0',
							left: '0',
							width: '100%',
							height: '100%',
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_talk_down.png' />) : (<div></div>)}
						{props.parameters.talksZero ? (<img style={{
     		               position: 'absolute',
     		               top: '0',
     		               left: '0',
     		               width: '100%',
    		                height: '100%',
    		                pointerEvents: 'none'
    		            }} src='./assets/images/general/footer/button_footer_talk_dis.png' />) : (<div></div>)}
					</button>
				</div>
				{props.parameters.talksZero ? (<div></div>) : (
					<div className="talks-container">
					<img src="./assets/images/general/footer/button_notification.png"/>
					<p className="talks-text">{props.parameters.talksNum} </p>
					</div>
				)}

				<div style={{
					position: 'absolute',
					bottom: '0px',
					left: '415px',
					width: '290px',
				}}>
					<button id='last-object-main' tabIndex={props.parameters.actionsZero ? -1 : 0} aria-label={`Actions. There are currently ${props.parameters.actionsNum} actions.`} className="pointer" style={{
						position: 'relative',
						background: 'transparent',
						pointerEvents: props.parameters.actionsZero ? 'none' : 'all'
       		    	}} onMouseOver={() => {
						setIsOverAction(true);
					}} onMouseEnter={() => {
						playSound('./assets/audio/Patient_Menu_Rollover');
					}} onMouseDown={() => {
						setIsOverAction(true);
					}} onMouseUp={() => {
						setIsOverAction(false);
					}} onMouseOut={() => {
						setIsOverAction(false);
					}} aria-disabled={props.parameters.actionsZero}
					onClick={() => {
						if(props.parameters.actionsZero) {
							return;
						}
						playSound('./assets/audio/Patient_Menu_Click');

						props.parameters.onActionsClicked();
					}}>
						<img style={{
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_actions_main.png' />
						{isOverAction ? (<img style={{
							position: 'absolute',
							top: '0',
							left: '0',
							width: '100%',
							height: '100%',
							pointerEvents: 'none'
						}} src='./assets/images/general/footer/button_footer_actions_down.png' />) : (<div></div>)}
						{props.parameters.actionsZero ? (<img style={{
     		               position: 'absolute',
     		               top: '0',
     		               left: '0',
     		               width: '100%',
    		                height: '100%',
    		                pointerEvents: 'none'
    		            }} src='./assets/images/general/footer/button_footer_actions_dis.png' />) : (<div></div>)}
					</button>
				</div>
				{props.parameters.actionsZero ? (<div></div>) : (
					<div className="actions-container">
					<img src="./assets/images/general/footer/button_notification.png"/>
					<p className="actions-text">{props.parameters.actionsNum} </p>
					</div>
				)}
			</div>
			
		</div>
	);

};

export interface FooterUIConfig extends BaseConfig {
	updateWindow: (windowToUse: Windows) => void;
	talksNum?: string;
	talksZero?: boolean;
	actionsNum?: string;
	actionsZero?: boolean;
    onPrClicked: () => void;
	onTalksClicked: () => void;
    onActionsClicked: () => void;
}

export default FooterUI;